import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";
import { usePWA } from "@/hooks/usePWA";

export const UpdatePrompt = () => {
  const { needsUpdate, updateApp } = usePWA();

  if (!needsUpdate) return null;

  return (
    <div className="fixed bottom-20 left-4 right-4 md:left-auto md:right-6 md:max-w-sm z-50 animate-in slide-in-from-bottom-4 duration-300">
      <div className="bg-card border border-border rounded-xl p-4 shadow-lg">
        <div className="flex items-center gap-3">
          <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
            <RefreshCw className="h-5 w-5 text-primary" />
          </div>
          
          <div className="flex-1 min-w-0">
            <h3 className="font-semibold text-foreground text-sm">
              Update Available
            </h3>
            <p className="text-xs text-muted-foreground">
              A new version is ready to install
            </p>
          </div>
          
          <Button size="sm" onClick={updateApp}>
            Update
          </Button>
        </div>
      </div>
    </div>
  );
};
